/*
 Copyright (c) Mayoral Moda Infantil, S.A.U. and affiliates.
 */

import { LoginType } from '@/types/global';

export const getLoginType = (isManager: boolean): LoginType => {
  if (isManager) {
    return LoginType.TALLERB_R;
  }

  return LoginType.TALLERB;
};

interface LoginDefaults {
  type: LoginType;
  username: string;
  password: string;
}

export const getLoginDefaultValues = (isManager: boolean): LoginDefaults => {
  const defaultLoginValues: LoginDefaults = {
    type: getLoginType(isManager),
    username: '',
    password: '',
  };

  if (process.env.NODE_ENV === 'development') {
    if (isManager) {
      defaultLoginValues.username = 'DEVELOPER1';
      defaultLoginValues.password = 'ed56kdfr';
    } else {
      defaultLoginValues.username = '5200';
      defaultLoginValues.password = ' ';
    }
  }

  return defaultLoginValues;
};
